export default {
  contactInfo: (state) => state.contactInfo,
};
